(ns frontend.view.modals.ai-deal-one-pager.sub
  (:require
   [frontend.view.modals.ai-deal-one-pager.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::generation
 :<- [::state]
 :generation)

(rf/reg-sub
 ::request-state
 :<- [::state]
 :request-state)

(rf/reg-sub
 ::error-category
 :<- [::state]
 :error-category)

(rf/reg-sub
 ::deduplicated?
 :<- [::state]
 (fn [state]
   (:deduplicated? state false)))
